<div id="background">
  <div class="wrapper">
    <div class="content">
      <img class="chapps-logo" src="assets/images/chapps-logo.png" alt="Chapps" />
      <mdb-card *ngIf="accountCreated">
        <mdb-card-body>
          <h5 class="text-center font-weight-bold indigo-text mb-4" [translate]="Localization.Success"></h5>
          <h6>{{ Localization.EmailHasBeenSendTo | translate}}<strong> {{registeredEmail}}</strong></h6>
          <div>{{ Localization.ThisEmailContainsALinkWhichLetYouContinueWithRegistartationProccess | translate}}</div>
        </mdb-card-body>
        <mdb-card-footer class="d-flex justify-content-center">
          <button type="button" class="btn btn-amber" data-dismiss="modal" mdbRippleRadius
            (click)="goToAccountLoginPage()">
            {{ Localization.Login | translate }}
          </button>
        </mdb-card-footer>
      </mdb-card>
      <mdb-card class="card-cascade narrower mb-4" [hidden]="accountCreated">
        <div class="view card-header indigo white-text text-center">
          {{ Localization.AccountRegistration | translate }}
        </div>
        <mdb-card-body>
          <form name="form" #registerForm="ngForm" (ngSubmit)="register()" novalidate>
            <label>{{Localization.Country | translate}}</label>
            <ng-select [items]="countries$ | async" [searchable]="true" [clearable]="false" [(ngModel)]="model.country"
              [selectOnTab]="true" bindValue="id" bindLabel="label" class="w-100" id="country" name="country"
              placeholder="{{Localization.Country | translate}} *" required #country="ngModel"
              (change)="onCountryChange($event)">
            </ng-select>
            <div *ngIf="doesSelectedCountryHaveStates()" class="d-flex align-items-center">
              <ng-select [items]="states" [searchable]="true" [clearable]="false" [(ngModel)]="model.state"
                bindLabel="label" bindValue="id" class="w-100" id="state" name="state"
                [placeholder]="statesLabel" #state="ngModel">
              </ng-select>
            </div>
            <label class="mt-4">{{Localization.Language | translate}}</label>
            <ng-select [items]="langs$ | async" [searchable]="true" [clearable]="false" [(ngModel)]="model.language"
              [selectOnTab]="true" bindValue="id" bindLabel="label" class="w-100" id="language" name="language"
              placeholder="{{ Localization.Language | translate}} *" required #language="ngModel"
              (change)="onLanguageChange()">
            </ng-select>
            <div class="md-form">
              <input [(ngModel)]="model.firstName" type="text" id="firstName" maxlength="100" class="form-control"
                name="firstName" #firstName="ngModel" required invalidFeedback="Localization.Required | translate"
                mdbInput>
              <label for="firstName">{{ Localization.FirstName | translate}} <span class="red-text">*</span></label>
            </div>
            <div class="md-form">
              <input [(ngModel)]="model.lastName" type="text" id="lastName" maxlength="100" class="form-control"
                name="lastName" #lastName="ngModel" required invalidFeedback="Localization.Required | translate"
                mdbInput>
              <label for="lastName">{{ Localization.LastName | translate}} <span class="red-text">*</span></label>
            </div>
            <div class="md-form">
              <input [(ngModel)]="model.businessName" type="text" id="company" maxlength="100" class="form-control"
                name="company" #company="ngModel" required mdbInput
                invalidFeedback="Localization.Required | translate">
              <label for="company">{{ Localization.Company | translate}} <span class="red-text">*</span></label>
            </div>
            <div class="md-form">
              <input [(ngModel)]="model.username" type="text" id="email" maxlength="100" class="form-control"
                name="email" required email #email="ngModel" mdbInput>
              <label for="email">{{ Localization.Email | translate}} <span class="red-text">*</span></label>
              <mdb-error *ngIf="email.invalid && (email.dirty || email.touched)">{{emailInputErrorMsg | translate}}
              </mdb-error>
            </div>
            <div class="md-form" [class.mt-6]="email.control.hasError('taken')">
              <input [(ngModel)]="model.password" type="password" id="password" maxlength="100" class="form-control"
                name="password" #password="ngModel" required mdbInput
                invalidFeedback="Localization.Required | translate"
                (keyup)="onPasswordChange()">
              <label for="password">{{ Localization.Password | translate}} <span class="red-text">*</span></label>
              <small class="text-danger" *ngIf="!doPasswordsMatch">
                {{ Localization.PasswordsDoNotMatch | translate}}
              </small>
            </div>
            <div class="md-form">
              <input [(ngModel)]="confirmPassword" type="password" id="cPassword" maxlength="100" class="form-control"
                name="cPassword" #cPassword="ngModel" required mdbInput
                invalidFeedback="Localization.Required | translate"
                (keyup)="onPasswordChange()">
              <label for="cPassword">{{ Localization.ConfirmPassword | translate}} <span
                  class="red-text">*</span></label>
              <small class="text-danger" *ngIf="!doPasswordsMatch">
                {{ Localization.PasswordsDoNotMatch | translate}}
              </small>
            </div>
            <div class="d-flex justify-content-center mt-4">
              <button mdbBtn type="submit" color="amber" mdbWavesEffect [disabled]="!isFormValid()">
                {{ Localization.Register | translate }}
              </button>
            </div>
          </form>
        </mdb-card-body>
      </mdb-card>
    </div>
  </div>
</div>
<div class="page-spinner" *ngIf="isRegisterInProgress">
  <mdb-spinner spinnerType="big" spinnerColor="blue"></mdb-spinner>
</div>